export const RealmRole = {
  VOUSER:process.env.REACT_APP_KEY_CLOAK_REALM_ROLE_USER,
  VOADMIN: process.env.REACT_APP_KEY_CLOAK_REALM_ROLE_ADMIN
};
